import { ToastsManager } from 'ng2-toastr';
import { Boitier } from '../../Model/Boitier';
import { CompteServer } from '../../Model/CompteServer';
import { Router } from '@angular/router';
import { ActivatedRoute, Params } from '@angular/router';
import { ServiceAdminService } from '../../Providers/service-admin.service';
import { Component, OnInit, ViewContainerRef, OnDestroy } from '@angular/core';
import 'rxjs/add/operator/switchMap';
import { Headers, RequestOptions } from '@angular/http';

/**
 * created by AHMED HAYEL
 * 
 */

@Component({
  selector: 'app-compte-details',
  templateUrl: './compte-details.component.html',
  styleUrls: ['./compte-details.component.css']
})
export class CompteDetailsComponent implements OnInit, OnDestroy {
  val: any = 0;
  compteServer: CompteServer = new CompteServer();
  boitiers: Boitier[] = [];
  BOITIER_INSTALLED: number = 0;
  BOITIER_NOT_INSTALLED: number = 0;
  selectedBoitier: Boitier = new Boitier();
  ID_COMPTE: number = 0;
  nbrBoitiers: number = 0;
  searchBoitier: string = "";
  intervalFrom: number = 0;
  intervalTo: number = 0;
  //for pagination
  public maxSize: number = 5;
  public bigTotalItems: number = 175;
  public bigCurrentPage: number = 1;
  public pagesFrom: number = 0;
  itemsPerPage = 15;
  constructor(public toastr: ToastsManager, vcr: ViewContainerRef, private route: ActivatedRoute, private service: ServiceAdminService, private router: Router) {
    this.toastr.setRootViewContainerRef(vcr);
  }

  ngOnInit() {
    if (this.service.isAuthenticated == false) {
      this.router.navigate(['/error']);
    } else {

      this.route.params.subscribe((params: Params) => {

        this.ID_COMPTE = (+params['idCompteClientServer']);

        this.service.getCompteServerById(this.ID_COMPTE).subscribe(_compteServer => {
          this.compteServer = _compteServer;
          this.intervalFrom = _compteServer.intervaleStart;
          console.log("interval start : " +_compteServer.intervaleStart);
          this.intervalTo = _compteServer.intervaleEnd;
          console.log("interval to : " +_compteServer.intervaleEnd);
          this.BOITIER_NOT_INSTALLED = this.compteServer.intervaleEnd - this.compteServer.intervaleStart + 1;
        });
        this.getBoitiersOfAccount(this.searchBoitier, this.ID_COMPTE, this.bigCurrentPage - 1, this.itemsPerPage);

      });
      this.val = setInterval(() => {
        this.getlastArchive(this.boitiers);
        console.log("constructor : " + this.val);
      }, 20000);
    }

  }
  ngOnDestroy() {

    this.val = clearInterval(this.val);
    console.log("destroy : " + this.val);

  }
  //=====================================
  //     Get All account
  //=====================================

  getBoitiersOfAccount(keyWord: string, idCompteServer: number, page: number, size: number) {

    this.service.getBoitierOfAccount(keyWord, idCompteServer, page, size).subscribe(_boitiers => {
      this.boitiers = _boitiers.content;
      for (let i = 0; i < this.boitiers.length; i++) {
        if (this.boitiers[i].etatBoitier == "INSTALLED") {
          this.boitiers[i].stat = true;
        } else {
          this.boitiers[i].stat = false;
        }

      }
      //this.intervalFrom = this.intervalFrom + _boitiers.totalElements;
      this.BOITIER_INSTALLED = _boitiers.totalElements;
      this.bigTotalItems = _boitiers.totalElements;
      this.getlastArchive(this.boitiers);
    });
  }

  //=====================================
  //     Search device by keyword
  //=====================================

  getBoitiersOfAccountByKeyWord(keyWord: string, idCompteServer: number, page: number, size: number) {


    this.service.getBoitierOfAccount(keyWord, idCompteServer, page, size).subscribe(_boitiers => {
      this.boitiers = _boitiers.content;
      for (let i = 0; i < this.boitiers.length; i++) {
        this.boitiers[i].stat = true;
      }
      this.bigTotalItems = _boitiers.totalElements;
      this.getlastArchive(this.boitiers);
    });
  }

  //=====================================
  //     Search device by keyword (click)
  //=====================================

  searchBoitiers() {
    this.bigCurrentPage = 1;
    if (this.searchBoitier == "") {
      this.getBoitiersOfAccount(this.searchBoitier, this.ID_COMPTE, this.bigCurrentPage - 1, this.itemsPerPage);
    } else {
      this.getBoitiersOfAccountByKeyWord(this.searchBoitier, this.ID_COMPTE, this.bigCurrentPage - 1, this.itemsPerPage);
    }
  }

  //=====================================
  //     change page
  //=====================================

  public pageChanged(event: any): void {
    this.bigCurrentPage = event.page;
    if (this.searchBoitier == "") {
      this.getBoitiersOfAccount(this.searchBoitier, this.ID_COMPTE, this.bigCurrentPage - 1, this.itemsPerPage);
    } else {
      this.getBoitiersOfAccountByKeyWord(this.searchBoitier, this.ID_COMPTE, this.bigCurrentPage - 1, this.itemsPerPage);
    }
  }

  //=====================================
  //     selected boitier 
  //=====================================

  onSelect(boitier: Boitier) {
    this.selectedBoitier = boitier;
  }

  //=====================================
  //     Update boitier 
  //=====================================

  updateBoitier() {
    let headers = new Headers({ 'Content-Type': 'application/json' });

    this.service.updateBoitier(this.selectedBoitier, this.ID_COMPTE, "label").subscribe(_boitier => {
      let indexboitier: number = 0;
      indexboitier = this.boitiers.findIndex(x => x.idBoitier == this.selectedBoitier.idBoitier);

      this.boitiers[indexboitier].label = _boitier.label;
      if (this.boitiers[indexboitier].etatBoitier == "INSTALLED") {
        this.boitiers[indexboitier].stat = true;
      } else {
        this.boitiers[indexboitier].stat = false;
      }
      this.toastr.success(' Device updated ', 'Success!')
    }, error => { this.toastr.error('There is a mistake', 'Error!') });
  }

  //=====================================
  //     Add Boitiers to Server Account
  //=====================================

  addBoitiers() {
    if (this.BOITIER_NOT_INSTALLED == 0) {
      this.toastr.error('can not add  devices because this account has not devices available', 'Error!');
    } else {

      this.service.addBoitiers(this.ID_COMPTE, this.nbrBoitiers).subscribe(_compteBoitiers => {

        this.BOITIER_NOT_INSTALLED = _compteBoitiers.compteserver.intervaleEnd - _compteBoitiers.compteserver.intervaleStart + 1;
        console.log(_compteBoitiers.compteserver.intervaleEnd,_compteBoitiers.compteserver.intervaleStart);
        this.BOITIER_INSTALLED = _compteBoitiers.boitiers;
        this.intervalFrom = _compteBoitiers.compteserver.intervaleStart;
        //this.intervalFrom = _compteBoitiers.compteserver.intervaleStart;
        this.intervalTo = _compteBoitiers.compteserver.intervaleEnd;
        this.bigTotalItems = _compteBoitiers.boitiers;
        this.bigCurrentPage = 1;
        this.getBoitiersOfAccount(this.searchBoitier, this.ID_COMPTE, this.bigCurrentPage - 1, this.itemsPerPage);
        this.toastr.success(this.nbrBoitiers + ' devices are added to account ', 'Success!')

      }, error => { this.toastr.error('There is a mistake', 'Error!') });
    }
  }

  //=====================================
  //     extends interval of Boitiers
  //=====================================

  extendIntervalOfBoitiers() {
    if (this.BOITIER_NOT_INSTALLED == 0) {
      let res = confirm("are you sure that you want extend this Account ?");
      if (res) {

        this.service.extendIntervalOfBoitiers(this.ID_COMPTE).subscribe(_compteServer => {

          this.BOITIER_NOT_INSTALLED = _compteServer.intervaleEnd - _compteServer.intervaleStart + 1;
          this.BOITIER_INSTALLED = _compteServer.boitiers.length;
          this.toastr.success('interval extended', 'Success!')
        });
      }

    } else {
      this.toastr.error('you can extend this interval because there is more devices available', 'Error!')
    }
  }

  //=====================================
  //     get last archive of device
  //=====================================

  getlastArchive(boitiers: Boitier[]) {
    for (let i = 0; i < this.boitiers.length; i++) {


      this.service.lastArchiveOfBoitier(this.boitiers[i].numBoitier).subscribe(_arch => {
        this.boitiers[i].dateLastTrame = _arch.dateLastTrame;

        if (_arch.latitude != 0 && _arch.longitude != 0) {
          this.boitiers[i].emplacement = (_arch.latitude.toFixed(3)) + " : " + (_arch.longitude.toFixed(3));
        }

        this.boitiers[i].vitesse = _arch.vitesse;
        this.boitiers[i].gpsLastTrame = _arch.gpsLastTrame;
        this.boitiers[i].gsmLastTrame = _arch.gsmLastTrame;
      });
    }
  }
  //=====================================
  //     Change Device Status
  //=====================================


  changeBoitierStatus(boitier: Boitier) {
    boitier.etatBoitier = "INSTALLED";

    let headers = new Headers({ 'Content-Type': 'application/json' });

    this.service.updateBoitier(boitier, this.ID_COMPTE, "etat").subscribe(_boitier => {
      let indexboitier: number = 0;
      indexboitier = this.boitiers.findIndex(x => x.idBoitier == boitier.idBoitier);

      if (this.boitiers[indexboitier].etatBoitier == "INSTALLED") {
        this.boitiers[indexboitier].stat = true;
      }/* else {
        this.boitiers[indexboitier].stat = false;
      }*/
      this.toastr.success(' Device is Installed now  ', 'Success!')
    }, error => { this.toastr.error('Table of this server is not Exists ', 'Error!') });
  }
}



// WEBPACK FOOTER //
// ./src/app/admin-component/compte-details/compte-details.component.ts